var React = require('react');

function Magnifier (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.246 12.074c-2.854 0-5.176-2.256-5.176-5.03 0-2.775 2.322-5.032 5.176-5.032s5.176 2.257 5.176 5.031c0 2.775-2.322 5.031-5.176 5.031zM18 16.577l-5.18-5.035a6.898 6.898 0 001.672-4.499C14.492 3.153 11.248 0 7.246 0 3.244 0 0 3.153 0 7.043s3.244 7.044 7.246 7.044c1.494 0 2.883-.44 4.036-1.194L16.536 18 18 16.577z","fillRule":"evenodd"}));
}

Magnifier.defaultProps = {"width":"18","height":"18"};

module.exports = Magnifier;

Magnifier.default = Magnifier;
